const RegisterConfig = {
	firstName: {
		value: "",
		readonly: true,
		label: "First Name",
		type: "text",
		errorMsg:
			"This is a mandatory field.",
		noAstrics: true,
		validation: {
			require: true,
		},
		maxLength: "255",
		valid: true
	},
	lastName: {
		value: "",
		readonly: true,
		label: "Last Name",
		type: "text",
		errorMsg:
			"This is a mandatory field.",
		noAstrics: true,
		validation: {
			require: true,
		},
		maxLength: "255",
		valid: true
	},
	email: {
		value: "",
		readonly: true,
		label: "Email",
		type: "text",
		errorMsg:
			"That doesn't look like a valid email address. Check for any errors and try again",
		noAstrics: true,
		validation: {
			require: true,
			email: true
		},
		maxLength: "255",
		valid: true
	},
  phone: {
    value: "",
    type: "number",
    label: "Phone",
    noAstrics: true,
    length: "4",
    validation: {
      require: false
    },
    maxLength: "64",
    valid: true
  }
};

export default RegisterConfig;